"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_native_1 = require("react-native");
var FlashList_1 = tslib_1.__importDefault(require("./FlashList"));
var AnimatedFlashList = react_native_1.Animated.createAnimatedComponent(FlashList_1.default);
exports.default = AnimatedFlashList;
//# sourceMappingURL=AnimatedFlashList.js.map